import { Faq as _Faq } from '@beef/smart-kit';
import { withAnalyticsFAQ } from "../../hocs";
export var Faq = withAnalyticsFAQ(_Faq);